import { Component } from '@angular/core';
import { SharedService } from './service/shared.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  
})
export class AppComponent {
  title = 'Direkt';

  constructor(public shared: SharedService) {

  }

  onClose(e: any) {
    console.log("close calling");
    this.shared.fromButtonLogin = false;
  }
  // lat = 51.678418;
  // lng = 7.809007;
}
